import React from "react"
import {withRouter} from "react-router-dom"
import PhotographerShowMainContainer from "./photographers/photographer_show_main_container"
import NavbarContainer from "./navbar/navbar_container"
import Modals from "../containers/PublicRouteContainer/modals"


class PhotographerShow extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isLargeScreen: true
    }

    this.updatePredicate = this.updatePredicate.bind(this)
    this.setModal = this.setModal.bind(this)
  }


  componentDidMount() {
    this.updatePredicate()
    window.addEventListener("resize", this.updatePredicate)
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updatePredicate)
  }

  updatePredicate() {
    this.setState({isLargeScreen: window.innerWidth > 750})
  }

  setModal(val) {
    if (val) {
      this.props.openNewModal()
    } else {
      this.props.closeModal()
    }
  }

  render() {
    return (
      <div className={this.props.currentUser ? "dashboardFullPageDiv" : "dashboardLoggedOutDiv"}>
        <NavbarContainer setModal={this.setModal}/>
        <Modals isLargeScreen={this.state.isLargeScreen} />
        <PhotographerShowMainContainer isLargeScreen={this.state.isLargeScreen}/>
      </div>
    )
  }
}

export default withRouter(PhotographerShow)